unit PrepareOperationMedicineItemListType;
{

/* Initial. */

}
interface

uses
  PrepareOperationMedicineItemType;

type
  TPrepareOperationMedicineItemListType = array of TPrepareOperationMedicineItemType;

implementation

end.
